import api from "../index";

export const addUpdateAccountInformation = (data) =>
  api.post("IndividualAccount/add-update-personalinfo", data);
export const addUpdateFinancialInfo = (data) =>
  api.post("IndividualAccount/add-update-financialinfo", data);
export const addUpdateDeclaration = (data) =>
  api.post("IndividualAccount/set-declarationinfo", data);
export const updateEkycStatus = (data, userId) =>
  api.put(`IndividualAccount/update-ekyc-status?userId=${userId}`, data);

export const getIndividualAccount = (params) =>
  api.get("IndividualAccount/get-individual-account?" + params);
export const getPersonalInfo = (id, userId) =>
  api.get(`IndividualAccount/get-personalinfo/${id}?userId=${userId}`);
export const getFinancialInfo = (id, userId) =>
  api.get(`IndividualAccount/get-financialinfo/${id}?userId=${userId}`);


export const getDeclarationInfo = (userId) =>
  api.get(`IndividualAccount/get-declarationinfo?userId=${userId}`);
export const getIndustryTypes = () => api.get("IndividualAccount/industry-types");

